module.exports = __webpack_public_path__ + "img/a-table-icon.eb88ae3d.svg";